import { useEffect, useState } from "react"
import { Navigate } from "react-router-dom"

import AppServices from "../../services/index"
import { useDispatch } from "react-redux"
import { toast } from "react-toastify"

import PageLoading from "../page-loading"

const ProtectedRoute = ({ children }) => {
  const dispatch = useDispatch()

  const [isLoading, setIsLoading] = useState(true)
  const [isAuth, setIsAuth] = useState(false)

  useEffect(() => {
    const checkAuth = async () => {
      try {
        setIsLoading(true)
        await AppServices.isAuthenticated()
        dispatch({ type: "IS_LOGGEDIN", payload: true })
        setIsAuth(true)
      } catch (e) {
        setIsAuth(false)
        dispatch({ type: "IS_LOGGEDIN", payload: false })
        if (
          e instanceof Error &&
          e.message !== "Unauthorized" &&
          e.message !== "Unauthenticated" &&
          !e.message.includes("403") &&
          !e.message.includes("401")
        ) {
          toast.error(e.message)
        }
      } finally {
        setIsLoading(false)
      }
    }
    checkAuth()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isLoading) {
    return <PageLoading />
  }

  if (!isAuth) {
    return <Navigate to="/login" replace />
  }
  return <> {children} </>
}

export default ProtectedRoute
